import { render, staticRenderFns } from "./KPromocodeEditForm.vue?vue&type=template&id=24fc7b92&"
import script from "./KPromocodeEditForm.vue?vue&type=script&lang=js&"
export * from "./KPromocodeEditForm.vue?vue&type=script&lang=js&"
import style0 from "./KPromocodeEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports